export enum LoiFormMode {
    AdminDefaults = 0,
    BuyerProfile = 1,
    LoiSubmissionEvent = 2,
}
